import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'
import { Button, Flex, theme } from 'antd'
import { useContext } from 'react'
import { CustomizeDiagramViewPortContext, DiagramViewPortContext } from '../DiagramViewPortContext.tsx'

const { useToken } = theme

export const DiagramToolbar = () => {
    const { token } = useToken()
    const { zoom } = useContext(DiagramViewPortContext)
    const {
        resetViewPort,
        zoomIn,
        zoomOut
    } = useContext(CustomizeDiagramViewPortContext)

    return (<Flex
        style={{ margin: token.marginXS, position: 'absolute', right: 0, zIndex: 1 }}
        gap={6}
        justify='center'
        align='center'
    >
        <Button
            size='small'
            onClick={resetViewPort}
        >Reset</Button>
        <Button
            size='small'
            title='Zoom in'
            onClick={zoomIn}
            icon={<ZoomInOutlined />}
        ></Button>
        <Button
            size='small'
            title='Zoom out'
            disabled={zoom <= 1}
            onClick={zoomOut}
            icon={<ZoomOutOutlined />}
        ></Button>
    </Flex>)
}
